import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_CONSTITUENCIES_REQUEST = "FETCH_CONSTITUENCIES_REQUEST";
export const FETCH_CONSTITUENCIES_SUCCESS = "FETCH_CONSTITUENCIES_SUCCESS";
export const FETCH_CONSTITUENCIES_FAILURE = "FETCH_CONSTITUENCIES_FAILURE";

export const CREATE_CONSTITUENCY_REQUEST = "CREATE_CONSTITUENCY_REQUEST";
export const CREATE_CONSTITUENCY_SUCCESS = "CREATE_CONSTITUENCY_SUCCESS";
export const CREATE_CONSTITUENCY_FAILURE = "CREATE_CONSTITUENCY_FAILURE";

// Fetch with pagination & filters
export const fetchConstituencies =
  (page = 1, limit = 10, filters = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CONSTITUENCIES_REQUEST });

    const token = localStorage.getItem("token");

    try {
      let queryParams = `?page=${page}&limit=${limit}`;

      if (filters.district_id) {
        queryParams += `&district_id=${filters.district_id}`;
      }
      if (filters.municipality_id) {
        queryParams += `&municipality_id=${filters.municipality_id}`;
      }
      if (filters.search) {
        queryParams += `&search=${encodeURIComponent(filters.search)}`;
      }

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/assembly-constituencies${queryParams}`,
        {
          headers: { authorization: token },
        },
      );

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_CONSTITUENCIES_SUCCESS,
          payload: {
            data: response.data.data,
            pagination: response.data.meta.pagination,
          },
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_CONSTITUENCIES_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_CONSTITUENCIES_FAILURE });
      toast.error(
        error.response?.data?.meta?.message || "Failed to fetch constituencies",
      );
      throw error;
    }
  };

//for bulk
export const fetchAllConstituencies = async (filters = {}, limit = 200000) => {
  const token = localStorage.getItem("token");

  let queryParams = `?page=1&limit=${limit}`;

  if (filters.district_id) {
    queryParams += `&district_id=${filters.district_id}`;
  }

  if (filters.municipality_id) {
    queryParams += `&municipality_id=${filters.municipality_id}`;
  }

  if (filters.search) {
    queryParams += `&search=${encodeURIComponent(filters.search)}`;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/assembly-constituencies${queryParams}`,
      {
        headers: {
          authorization: token,
        },
      },
    );

    // Check if response has data
    if (response.data && response.data.data) {
      return response.data.data;
    } else {
      console.error("No data found in response:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching all constituencies:", error);
    toast.error("Failed to fetch data for export");
    return [];
  }
};

// Create
export const createConstituency = (data) => async (dispatch) => {
  dispatch({ type: CREATE_CONSTITUENCY_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/admin/assembly-constituencies`,
      data,
      {
        headers: { authorization: token },
      },
    );

    if (response.data.meta.status) {
      dispatch({
        type: CREATE_CONSTITUENCY_SUCCESS,
        payload: response.data.data,
      });
      toast.success("Constituency created successfully");
      return response.data;
    } else {
      dispatch({ type: CREATE_CONSTITUENCY_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: CREATE_CONSTITUENCY_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to create constituency",
    );
    throw error;
  }
};
